<div class="form-parent">
  <kgrid [apiName]="apiName" [label]="label" [areaName]="areaName" [name]="apiName" [inputEditorform]="inputEditorform"> </kgrid>
</div>
